module.exports = __webpack_public_path__ + "img/pflegeplan-active.b8394cca.svg";